<clr-wizard
    #techSupportWizard
    clrWizardSize="xl"
    [clrWizardOpen]="true"
    [clrWizardClosable]="true"
    (clrWizardOnCancel)="handleClose()"
    (clrWizardOnClose)="handleClose()"
>
    <clr-wizard-title>{{ l10nKeys.techSupportLabel | vtranslate }}</clr-wizard-title>
    <clr-wizard-button
        type="cancel"
        (click)="handleClose()"
    >
        {{ globalL10nKeys.closeLabel | vtranslate }}
    </clr-wizard-button>
    <clr-wizard-button 
        type="next"
        [disable]="isNextButtonDisabled"
    >
        {{ globalL10nKeys.nextLabel | vtranslate }}
    </clr-wizard-button>
    <clr-wizard-page #preCheckPage>
        <ng-template clrPageTitle> {{ l10nKeys.preCheckLabel | vtranslate }} </ng-template>
        <tech-support-wizard-page
            [techSupportPackage]="selectedPackage"
            [page]="'preCheck'"
        ></tech-support-wizard-page>
    </clr-wizard-page>
    <clr-wizard-page #packagingPage>
        <ng-template clrPageTitle> {{ l10nKeys.packagingLabel | vtranslate }} </ng-template>
        <tech-support-wizard-page
            [techSupportPackage]="selectedPackage"
            [page]="'packaging'"
        ></tech-support-wizard-page>
    </clr-wizard-page>
</clr-wizard>
